export const proxyUrl = (url: string) => {
  const parsed = new URL(url);
  const urlObj = new URL(location.origin);
  urlObj.pathname = `/proxy/${parsed.hostname}${parsed.pathname}`;
  urlObj.search = parsed.search;
  return urlObj.toString();
};
